import {Action} from '@ngrx/store';
import {Group} from '../../../models/group';
import {BijbEvent} from '../../../models/bijb-event';

export class UpdateGroupAction implements Action {
  public static readonly type = 'UpdateGroupAction';

  constructor(public bijbEvent: BijbEvent, public group: Group) {
  }

  public type = UpdateGroupAction.type;
}
